import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/categories`,
  FETCH: `${apiUrlConfig.apiEndPoint()}/categories/:categoryId`,
};

function insertIdToUrl(url, id) {
  return url.replace(':categoryId', id);
}

class CategoryApi {
  static getDetails(categoryId) {
    const INDEX_URL = insertIdToUrl(URLS.FETCH, categoryId);
    return AuthenticatedRequestService.get(INDEX_URL);
  }

  /**
   * gets all categories
   */
  static getAll() {
    return AuthenticatedRequestService.get(URLS.INDEX);
  }
}

export default CategoryApi;



// WEBPACK FOOTER //
// ./src/apis/Category.js